import { DateTime } from "luxon";
import { fetchLatestBidEventByReferenceNumber } from "../../api/bid";
import { BID_SCHEDULED_STATUS, BID_STATUS } from "./bidConstants";
import { API_POLLING_INTERVAL, BID_API_TIMEOUT, IAM_CONTRACT, TWU_CONTRACT } from "../constants";
import { getTimeZoneFromSwaStation, getStationTimeZoneLuxonDateTimeFromIsoDateTimeString } from "../timeZoneService";

export const isDeletedBid = (status) => {
  return status === BID_STATUS.DELETED;
};

export const isPendingBid = (status) => {
  return status === BID_STATUS.PENDING;
};

export const isOpenBid = (status) => {
  return status === BID_STATUS.OPEN;
};

export const isClosedBid = (status) => {
  return status === BID_STATUS.CLOSED;
};

export const isAwardedBid = (status) => {
  return status === BID_STATUS.AWARDED;
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const longPollingBidFetch = async (referenceNumber, userSession, requestId) => {
  const startTime = DateTime.now();

  async function fetchBid() {
    console.log("Fetching bid w referenceNumber: ", referenceNumber);
    try {
      const res = await fetchLatestBidEventByReferenceNumber(userSession.eid, referenceNumber);
      const response = await res.json();
      if (response?.event?.requestId === requestId) {
        console.log("Found requestId in db, success!");
      } else if (!response || response.error) {
        const errorMessage = "Failure in bid S3 upload - polling call failed";
        console.error(errorMessage);
        throw Error(errorMessage);
      } else {
        const currentTime = DateTime.now();
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < BID_API_TIMEOUT) {
          // recursive call till requestId matches or timeout happens
          await delay(API_POLLING_INTERVAL);
          await fetchBid();
        } else {
          const errorMessage = "Failure in bid S3 upload - polling call timeout";
          console.error(errorMessage);
          throw Error(errorMessage);
        }
      }
    } catch (err) {
      const errorMessage = "Failure in bid S3 upload: ";
      console.error(errorMessage, err);
      throw Error(errorMessage);
    }
  }

  await fetchBid();
};

export const getS3ObjectName = async (referenceNumber, station) => {
  const timeZone = await getTimeZoneFromSwaStation(station);
  const s3ObjectName = `${referenceNumber}%2F${DateTime.now().setZone(timeZone).toISO()}_bid.json`;
  return s3ObjectName;
};

export const getEmployeeFtCount = (employees) => {
  return employees?.filter((employee) => employee.ftpt === "FT").length;
};

export const getEmployeePtCount = (employees) => {
  return employees?.filter((employee) => employee.ftpt === "PT").length;
};

export const getPermBidDealineEpochTimestamp = (bidData) => {
  let permBidDeadline = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(bidData.windowEndDate, bidData.station);

  if (bidData.unionContract === IAM_CONTRACT) {
    permBidDeadline = permBidDeadline.set({ hour: 23, minute: 59, second: 59 }).minus({ days: 1 });
    return String(permBidDeadline.toMillis());
  } else if (bidData.unionContract === TWU_CONTRACT) {
    return String(permBidDeadline.toMillis());
  } else {
    console.error("Unknown contract in getPermBidDealineEpochTimestamp. bidData: ", bidData);
  }
};

export const getCurrentFormScheduledStatus = (isReadyToBeScheduledByUser) => {
  return isReadyToBeScheduledByUser ? BID_SCHEDULED_STATUS.SCHEDULED : BID_SCHEDULED_STATUS.NOT_SCHEDULED;
};

export const isPermBidEligible = (unionContract) => {
  return unionContract === IAM_CONTRACT || unionContract === TWU_CONTRACT;
};
